export const ProviderTableHeaders= [
  { label: "ID", id: "providerId", isSortable: true },
  { label: "Name", id: "firstName", isSortable: true },
  // { label: "Middle Name", id: "middleName", isSortable: true },
  // { label: "Last Name", id: "lastName", isSortable: true },
  // { label: "Organization", id: "providerId", isSortable: true },

  { label: "Organization", id: "organizationId", isSortable: true },
  { label: "Date of Birth", id: "dateOfBirth", isSortable: true },
  { label: "Email", id: "email", isSortable: true },
  { label: "Phone", id: "phone", isSortable: true },
  { label: "Address", id: "address", isSortable: false },
  { label: "Street", id: "street", isSortable: true },
  { label: "City", id: "city", isSortable: true },
  { label: "State", id: "state", isSortable: true },
  { label: "Zipcode", id: "zipcode", isSortable: true },
  { label: "Gender", id: "gender", isSortable: true },
  { label: "NPI Number", id: "npiNumber", isSortable: true },
  { label: "Specializations", id: "specializations", isSortable: false },
  { label: "Taxonomies", id: "taxonomies", isSortable: false },
  { label: "Status", id: "status", isSortable: true },
  //activePatientsCount
  { label: "Active Patients", id: "activePatientsCount", isSortable: true },
  { label: "Created At", id: "createdAt", isSortable: true },
  { label: "Updated At", id: "updatedAt", isSortable: true },
];


export const practitionersTableHeaders = [
  { id: "practitionerId", label: "ID", isSortable: true },
  { id: "firstName", label: "Name", isSortable: true },
  // { id: "lastName", label: "Last Name", isSortable: true },
  // { id: "middleName", label: "Middle Name", isSortable: true },
  { id: "email", label: "Email", isSortable: true },
  { id: "phone", label: "Phone", isSortable: true },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: true },
  { id: "address", label: "Address", isSortable: false },
  { id: "street", label: "Street", isSortable: true },
  { id: "city", label: "City", isSortable: true },
  { id: "state", label: "State", isSortable: true },
  { id: "zipcode", label: "Zipcode", isSortable: true },
  { id: "gender", label: "Gender", isSortable: true },
  { id: "status", label: "Status", isSortable: true },
  { id: "providerId", label: "Provider Name", isSortable: true },
  { id: "npiNumber", label: "NPI Number", isSortable: true },
  { id: "specializations", label: "Specializations", isSortable: false },
  { id: "taxonomies", label: "Taxonomies", isSortable: false },
  { label: "Active Patients", id: "activePatientsCount", isSortable: true },

  // { id: "createdBy", label: "Created By", isSortable: true },
  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "updatedAt", label: "Updated At", isSortable: true },
  // { id: "__v", label: "Version", isSortable: false }
];

export const caretakerTableHeaders = [
   { id: "caretakerId", label: "ID", isSortable: false },
  { id: "firstName", label: "Name", isSortable: false },
  // { id: "lastName", label: "Last Name", isSortable: true },
  // { id: "middleName", label: "Middle Name", isSortable: true },
  { id: "email", label: "Email", isSortable: false },
  { id: "phone", label: "Phone", isSortable: false },
  { id: "address", label: "Address", isSortable: false },
  { id: "gender", label: "Gender", isSortable: false },
  { id: "type", label: "Type", isSortable: true },
  { id: "assignedOrganizations", label: "Assigned Organizations", isSortable: false },
  { id: "activePatientsCount", label: "Active Patients", isSortable: false },
  { id: "createdAt", label: "Created At", isSortable: false },
  { id: "updatedAt", label: "Updated At", isSortable: false },
  // { id: "__v", label: "Version", isSortable: false },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: false },
  { id: "status", label: "Status", isSortable: true }
];

export const organizationHeaders = [
  // { id: "_id", label: "ID", isSortable: true },
  { id: "organizationId", label: "ID", isSortable: true },

  { id: "organizationName", label: "Organization Name", isSortable: true },
  { id: "ownerFirstName", label: "Owner's Name", isSortable: true },
  { id: "email", label: "Email", isSortable: true },
  { id: "phoneNumber", label: "Phone Number", isSortable: true },
  { id: "timezone", label: "Timezone", isSortable: false },
  { id: "activePatients", label: "Active Patients", isSortable: true },
  { id: "totalPatients", label: "Total Patients", isSortable: true },

  { id: "address", label: "Address", isSortable: true },
  // { id: "address2", label: "Address 2", isSortable: true },
  { id: "street", label: "Street", isSortable: true },
  { id: "city", label: "City", isSortable: true },
  // { id: "city2", label: "City 2", isSortable: true },
  // { id: "createdBy", label: "Created By", isSortable: true },
  // { id: "ownerLastName", label: "Owner Last Name", isSortable: true },
  // { id: "ownerMiddleName", label: "Owner Middle Name", isSortable: true },
  { id: "state", label: "State", isSortable: true },
  // { id: "state2", label: "State 2", isSortable: true },
  // { id: "street2", label: "Street 2", isSortable: true },
  { id: "zipCode", label: "Zip Code", isSortable: true },
  { id: "providerGroupNPI", label: "Provider Group NPI", isSortable: true },
  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "updatedAt", label: "Updated At", isSortable: true },
  // { id: "zipCode2", label: "Zip Code 2", isSortable: true },
  // { id: "billerAddress", label: "Biller Address", isSortable: true },
  // { id: "billerCity", label: "Biller City", isSortable: true },
  // { id: "billerEmail", label: "Biller Email", isSortable: true },
  // { id: "billerFirstName", label: "Biller First Name", isSortable: true },
  // { id: "billerLastName", label: "Biller Last Name", isSortable: true },
  // { id: "billerLocation", label: "Biller Location", isSortable: true },
  // { id: "billerMiddleName", label: "Biller Middle Name", isSortable: true },
  // { id: "billerPhoneNumber", label: "Biller Phone Number", isSortable: true },
  // { id: "billerState", label: "Biller State", isSortable: true },
  // { id: "billerStreet", label: "Biller Street", isSortable: true },
  // { id: "billerZipCode", label: "Biller Zip Code", isSortable: true },
  // { id: "billingAddress", label: "Billing Address", isSortable: true },
  // { id: "billingCity", label: "Billing City", isSortable: true },
  // { id: "billingState", label: "Billing State", isSortable: true },
  // { id: "billingStreet", label: "Billing Street", isSortable: true },
  // { id: "billingZipCode", label: "Billing Zip Code", isSortable: true },
  // { id: "groupNPI", label: "Group NPI", isSortable: true },
  // { id: "groupName", label: "Group Name", isSortable: true },
  // { id: "groupTaxId", label: "Group Tax ID", isSortable: true },
  // { id: "medicalId", label: "Medical ID", isSortable: true },
  // { id: "primaryFax", label: "Primary Fax", isSortable: true },
  // { id: "primaryPhoneNumber", label: "Primary Phone Number", isSortable: true },
  // { id: "ptan", label: "PTAN", isSortable: true },
  // { id: "taxonomyCode", label: "Taxonomy Code", isSortable: true },
  // { id: "tin", label: "TIN", isSortable: true },
  // { id: "tradingPartnerId", label: "Trading Partner ID", isSortable: true },
];

export const patientTableHeaders = [
  { id: "patientId", label: "ID", isSortable: false },
  { id: "firstName", label: "Name", isSortable: false },
  // { id: "middleName", label: "Middle Name", isSortable: true },
  // { id: "lastName", label: "Last Name", isSortable: true },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: false },
  { id: "gender", label: "Gender", isSortable: false },
  { id: "heightValue", label: "Height Value", isSortable: false },
  { id: "weightValue", label: "Weight Value", isSortable: false },
  { id: "email", label: "Email", isSortable: false },
  { id: "primaryNumber", label: "Primary Number", isSortable: false },
  { id: "landlineExtension", label: "Landline Extension", isSortable: false },
  { id: "address", label: "Address", isSortable: false },
  { id: "street", label: "Street", isSortable: false },
  { id: "city", label: "City", isSortable: false },
  { id: "state", label: "State", isSortable: false },
  { id: "zipCode", label: "Zip Code", isSortable: false },
  { id: "primaryInsuranceName", label: "Primary Insurance Name", isSortable: false },
  { id: "primaryInsuranceNumber", label: "Primary Insurance Number", isSortable: false },
  { id: "secondaryInsuranceName", label: "Secondary Insurance Name", isSortable: false },
  { id: "secondaryInsuranceNumber", label: "Secondary Insurance Number", isSortable: false },
  { id: "dx1", label: "DX 1", isSortable: false },
  { id: "dx2", label: "DX 2", isSortable: false },
  { id: "dx3", label: "DX 3", isSortable: false },
  { id: "dx4", label: "DX 4", isSortable: false },
  { id: "programs", label: "Programs", isSortable: false },
  { id: "organizationId", label: "Organization Name", isSortable: false },
  { id: "facility", label: "Facility Name", isSortable: false },
  { id: "assignedProviderId", label: "Provider Name", isSortable: false },
  { id: "assignedCaretakerIds", label: "Caretaker Names", isSortable: false }, // array
  // { id: "createdBy", label: "Created By", isSortable: true },
  // { id: "parentUserId", label: "Parent User ID", isSortable: true },
  
  // { id: "totalMinutes", label: "Total Minutes", isSortable: true },
  { id: "currentMonthMinutes", label: "Total Minutes", isSortable: true , sortKey: "totalMinutes"},
  { id: "ccmCurrentMonthMinutes", label: "CCM Minutes", isSortable: true , sortKey: "ccmMinutes"},
  { id: "pcmCurrentMonthMinutes", label: "PCM Minutes", isSortable: true , sortKey: "pcmMinutes"},
  { id: "rpmCurrentMonthMinutes", label: "RPM Minutes", isSortable: true , sortKey: "rpmMinutes"},
  { id: "readingCount", label: "Reading Count", isSortable: true , sortKey: "readingCount"},
  {id: "lastVisit", label : "Last visit Date", isSortable: false},

  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "updatedAt", label: "Updated At", isSortable: false },
  { id: "typeOfPatient", label: "Type of Patient", isSortable: true },
  { id: "patientTimezoneDisplay", label: "Timezone", isSortable: false },
  { id: "status", label: "Status", isSortable: true },
];

export const needsVerificationPatientTableHeaders = [
  { id: "athenaId", label: "Athena ID", isSortable: true },
  { id: "firstName", label: "Name", isSortable: true },
  { id: "email", label: "Email", isSortable: true },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: true },
  { id: "primaryNumber", label: "Primary Number", isSortable: true },
  { id: "typeOfPatient", label: "Type of Patient", isSortable: true },
  { id: "weightValue", label: "Weight Value", isSortable: true },
  { id: "gender", label: "Gender", isSortable: true },
  { id: "eligibleForRpm", label: "Eligible for RPM", isSortable: true },
  { id: "icdCodesCount", label: "No. of ICD Codes", isSortable: true },
];

/** Admin user management list (local / API-backed rows with `_id`). */
export const userManagementTableHeaders = [
  { id: "firstName", label: "Name", isSortable: false },
  { id: "email", label: "Email", isSortable: false },
  { id: "status", label: "Status", isSortable: false },
  { id: "position", label: "Position", isSortable: false },
];

/** Provider portal — managers under `/providers/me/managers`. */
export const providerManagerTableHeaders = [
  { id: "firstName", label: "Name", isSortable: false },
  { id: "email", label: "Email", isSortable: false },
];

export const ccmPatientsHeaders = [
  { id: "patientId", label: "ID", isSortable: false },

  { id: "firstName", label: "Name", isSortable: false },
  { id: "email", label: "Email", isSortable: false },
  { id: "primaryNumber", label: "Mobile Number", isSortable: false },
  {id: "lastVisit", label : "Last visit Date", isSortable: true},
 
  { id: "createdAt", label: "Created Date", isSortable: true },
  { id: "createdBy", label: "Created By", isSortable: false },
    // { id: "totalMinutes", label: "Total Minutes", isSortable: true },
  { id: "currentMonthMinutes", label: "CCM Minutes", isSortable: false },
  { id: "ccmMinutes", label: "CCM Minutes", isSortable: true },
  { id: "pcmMinutes", label: "PCM Minutes", isSortable: true },
  { id: "rpmMinutes", label: "RPM Minutes", isSortable: true },
  // { id: "hasCCMCarePlan", label: "Careplan exist", isSortable: true },
  { id: "lastCarePlanStatus", label: "Careplan Status", isSortable: false },
  { id: "lastTreatmentPlanStatus", label: "Treatment Plan Status", isSortable: false },
  { id: "typeOfPatient", label: "Type of Patient", isSortable: true },
  { id: "readingCount", label: "Reading Count", isSortable: false },
  {id: "status", label : "Status", isSortable: true},
]
 let filters = [
  {label : "Status",
    key: 'status',
    isMutli : true,
    values: [
      {
        label : "Active",
        value : "active"
      },
      {
        label : "Inactive",
        value : "inactive"
      }
    ]



  }
 ]


 export const careplanHeaders= [
  { id: "careTakerId", label: " Caretaker name", isSortable: true },
  // { id: "plan", label: "Care Plan Type", isSortable: true },
  { id: "icdCodes", label: " ICD Codes ", isSortable: true },
  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "updatedAtLocal", label: "Updated At", isSortable: true },
 ]
  export const pcmcareplanHeaders= [
  // { id: "patientId", label: " Patient name", isSortable: true },
  { id: "careTakerId", label: " Caretaker name", isSortable: true },
  // { id: "plan", label: "Care Plan Type", isSortable: true },
  { id: "icdCode", label: " ICD Codes ", isSortable: true },


  { id: "createdAt", label: "Created At", isSortable: true },

  { id: "updatedAt", label: "Updated At", isSortable: true },

 ]
 export const treatmentPlanHeaders= [
  // { id: "patientId", label: " Patient name", isSortable: true },
  { id: "careTakerId", label: " Caretaker name", isSortable: true },
  // { id: "icdCodes", label: " ICD Codes ", isSortable: true },
  { id: "deviceType", label: " Device Types ", isSortable: true },
  { id: "status", label: " Status ", isSortable: true },
  { id: "createdAtLocal", label: "Created At", isSortable: true },
  { id: "updatedAtLocal", label: "Updated At", isSortable: true },
 ]

 export const facilitiesTableHeaders = [
   { id: "facilityId", label: "ID", isSortable: true },
  { id: "name", label: "Name", isSortable: true },

  { id: "timezoneDisplay", label: "Timezone", isSortable: false },

  { id: "street", label: "Address", isSortable: false },
  { id: "city", label: "City", isSortable: false },
  { id: "state", label: "State", isSortable: false },
  { id: "zipcode", label: "Zipcode", isSortable: false },


];
 export const questionsConfig = [
   { id: "name", label: "Template name", isSortable: false },
   { id: "icdCodes", label: "ICD CODES", isSortable: false },




];

export const requestTableHeaders = [
  // { id: "_id", label: "ID", isSortable: false },
  { id: "program", label: "Program", isSortable: true },
  { id: "reason", label: "Reason", isSortable: false },
  { id: "status", label: "Status", isSortable: true },
  { id: "createdAt", label: "Requested On", isSortable: true },
  { id: "updatedAt", label: "Updated On", isSortable: true },

  // Patient info
  // { id: "patientId", label: "Patient ID", isSortable: true },
  { id: "patientFirstName", label: "Patient's Name", isSortable: true },
  // { id: "patientLastName", label: "Patient Last Name", isSortable: true },
  { id: "patientEmail", label: "Patient Email", isSortable: false },
  { id: "patientPatientId", label: "Patient Code", isSortable: true },

  // Requested By
  // { id: "requestedById", label: "Requested By ID", isSortable: false },
  { id: "requestedByName", label: "Requested By Name", isSortable: true },
  { id: "requestedByEmail", label: "Requested By Email", isSortable: false },
];


export const billingAnalysisHeaders = [
  { id: "patientId", label: "ID", isSortable: false },
  { id: "firstName", label: "Name", isSortable: false },
  // { id: "middleName", label: "Middle Name", isSortable: true },
  // { id: "lastName", label: "Last Name", isSortable: true },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: false },
  { id: "gender", label: "Gender", isSortable: false },
  { id: "heightValue", label: "Height Value", isSortable: false },
  { id: "weightValue", label: "Weight Value", isSortable: false },
  { id: "email", label: "Email", isSortable: false },
  { id: "primaryNumber", label: "Primary Number", isSortable: false },
  { id: "landlineExtension", label: "Landline Extension", isSortable: false },
  { id: "street", label: "Street", isSortable: false },
  { id: "city", label: "City", isSortable: false },
  { id: "state", label: "State", isSortable: false },
  { id: "zipCode", label: "Zip Code", isSortable: false },
  { id: "primaryInsuranceName", label: "Primary Insurance Name", isSortable: false },
  { id: "primaryInsuranceNumber", label: "Primary Insurance Number", isSortable: false },
  { id: "secondaryInsuranceName", label: "Secondary Insurance Name", isSortable: false },
  { id: "secondaryInsuranceNumber", label: "Secondary Insurance Number", isSortable: false },
  { id: "dx1", label: "DX 1", isSortable: false },
  { id: "dx2", label: "DX 2", isSortable: false },
  { id: "dx3", label: "DX 3", isSortable: false },
  { id: "dx4", label: "DX 4", isSortable: false },
  { id: "programs", label: "Programs", isSortable: false },
  { id: "organizationId", label: "Organization Name", isSortable: false },
  { id: "address", label: "Address", isSortable: false },
  { id: "facilityName", label: "Facility Name", isSortable: false },
  { id: "assignedProviderId", label: " Provider Name", isSortable: false },
  { id: "assignedCaretakerIds", label: " Caretaker IDs", isSortable: false }, // array
  // { id: "createdBy", label: "Created By", isSortable: true },
  // { id: "parentUserId", label: "Parent User ID", isSortable: true },
  
  {id: "lastVisit", label : "Last visit Date", isSortable: false},
 
  // { id: "totalMinutes", label: "Total Minutes", isSortable: true },
  { id: "currentMonthMinutes", label: "Total Minutes", isSortable: true , sortKey: "totalMinutes"},
  { id: "ccmCurrentMonthMinutes", label: "CCM Minutes", isSortable: true , sortKey: "ccmMinutes"},
  { id: "pcmCurrentMonthMinutes", label: "PCM Minutes", isSortable: true , sortKey: "pcmMinutes"},
  { id: "rpmCurrentMonthMinutes", label: "RPM Minutes", isSortable: true , sortKey: "rpmMinutes"},
  { id: "apcmCurrentMonthMinutes", label: "APCM Minutes", isSortable: false },
  { id: "readingCount", label: "Reading Count", isSortable: true , sortKey: "readingCount"},
  { id: "hasCCMCarePlan", label: "CCM Care Plan", isSortable: false },
  { id: "hasPCMCarePlan", label: "PCM Care Plan", isSortable: false },
  { id: "hasRPMCarePlan", label: "Treatment Plan", isSortable: false },
  { id: "apcm", label: "APCM", isSortable: false },
  { id: "hasAPCMCarePlan", label: "APCM Care Plan", isSortable: false },
  { id: "lastPlanProgram", label: "Last Plan Program", isSortable: false },
  { id: "lastPlanCreatedAt", label: "Last Plan Created At", isSortable: false },
  { id: "lastEngagementSource", label: "Last Engagement Source", isSortable: false },
  { id: "lastEngagementAt", label: "Last Engagement At", isSortable: false },
  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "updatedAt", label: "Updated At", isSortable: false },
  { id: "typeOfPatient", label: "Type of Patient", isSortable: true },
  { id: "status", label: "Status", isSortable: true },
];





// Enrolment Date
// Devices
// Monitoring Type
// address

export const reportHeaders = [
  { id: "patientId", label: "ID", isSortable: false },
  { id: "firstName", label: "Name", isSortable: false },
  { id: "dateOfBirth", label: "Date of Birth", isSortable: false },
  { id: "organizationId", label: "Organization Name", isSortable: true },
  { id: "patientTimezoneDisplay", label: "Timezone", isSortable: false },
  {id: "enrolledBy", label: "Enrolled By", isSortable: false },
  { id: "enrolledDate", label: "Enrollment Date", isSortable: true },
  { id: "assignedProviderId", label: " Provider Name", isSortable: false },
  { id: "programs", label: "Monitoring Type", isSortable: false }, // array
  {id: "deviceNames", label: "Devices", isSortable: false},
  // { id: "street", label: "Street", isSortable: true },
  // { id: "city", label: "City", isSortable: true },
  // { id: "state", label: "State", isSortable: true },
  // { id: "zipCode", label: "Zip Code", isSortable: true },
  { id: "address" , label: "Address", isSortable: false },
  { id: "status", label: "Status", isSortable: true },
];

export const NursingNotesTableHeaders = [
  { id: "program", label: "Program", isSortable: true },
 
  { id: "authorName", label: "Author Name", isSortable: true },
  { id: "duration", label: "Duration", isSortable: true },
  { id: "dateTime", label: "Date Time", isSortable: true ,},
   { id: "content", label: "Content", isSortable: true },

  //duration
  // { id: "createdAt", label: "Created At", isSortable: true },

];

export const nursingNotesPopupHeaders = [
  // { label: "ID", id: "_id", isSortable: true },
  { label: "Content", id: "content", isSortable: true },
  { label: "Author Name", id: "authorName", isSortable: true },
  { label: "Type", id: "note_type", isSortable: true },
  // { label: "Patient ID", id: "patientId", isSortable: true },
  { label: "Program", id: "program", isSortable: true },
  { label: "Care Type", id: "careType", isSortable: true },
  { label: "Date Time", id: "dateTime", isSortable: true },
  { label: "Duration", id: "duration", isSortable: true },
  { label: "Created By", id: "createdBy", isSortable: false }, // nested object
  { label: "Created At", id: "createdAt", isSortable: true },
  { label: "Updated At", id: "updatedAt", isSortable: true },
];
